var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"status-label",class:_vm.statusClass[_vm.status]},[_vm._v(" "+_vm._s(_vm.count ? `${_vm.count} ${_vm.statusText[_vm.status]}` : _vm.statusText[_vm.status])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }